import firebase from "firebase";
import Vue from "vue"
var blank_survey = {
	id: '',
	elements: []
}

const state = []


const actions = {
	new({commit}, props){
		var survey = {...blank_survey}
		for( var key in props ){
			survey[key] = props[key]
		}
		let now = firebase.firestore.Timestamp.fromDate(new Date());
		survey.created = now;
		survey.updated = now;
		commit( "ADD_SURVEY", survey );
		return true;
	},
	addQuestion({state, commit}, {id, question}){
		var survey = state.find( a => a.id == id)
		survey.elements.push( question );
		commit("UPDATE_SURVEY", survey )
	},
	deleteQuestion({state, commit}, {id, question_name}){
		var survey = state.find( a => a.id == id )
		var question = survey.elements.find( q => q.name == question_name ); 
		survey.elements.splice( survey.elements.indexOf(question), 1 );
		commit("UPDATE_SURVEY", survey )
	},
	moveQuestion({state, commit}, {id, question_name, direction}){
		let delta = direction == "up" ? -1 : 1 ;
		var survey = state.find( s => s.id == id )
		var question = survey.elements.find( q => q.name == question_name );
		var index = survey.elements.indexOf(question);
		var newIndex = index + delta;
		if (newIndex < 0  || newIndex == survey.elements.length) return;
		var indexes = [index, newIndex].sort((a, b) => a - b); 
		survey.elements.splice(indexes[0], 2, survey.elements[indexes[1]], survey.elements[indexes[0]]); 
		commit("UPDATE_SURVEY", survey )
	},
	update({commit}, survey ){
		commit("UPDATE_SURVEY", survey );
	},
	save({dispatch, commit }, survey ){
		commit("UPDATE_SURVEY", survey );
		dispatch("updateDoc", {
			doc: `surveys/${survey.id}`, 
			action: "set", 
			data: survey
		}, {root: true}).then( () => {return true} ).catch(e => e )
	},
	emptyNewSurvey({commit}, survey){
		commit("EMPTY_SURVEY", survey );
	},
	getOne({commit}, id){
		var subscription = firebase.firestore().doc(`surveys/${id}`).onSnapshot(doc => {
			var user =  doc.data();
			user.id = doc.id;
			commit("SET_ONE",  {doc: user, collection: "surveys"}, {root:true} )
		})
		commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})
	},
	getAll({ commit }){
		var subscription = firebase.firestore().collection("surveys").onSnapshot(snap => {
			snap.forEach( doc => {
				var user = doc.data()
				user.id = doc.id;
				commit("SET_ONE",  {doc: user, collection: "surveys"}, {root:true} )  
			})
		});
		commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})

	},	
} 

const mutations = {
	ADD_SURVEY(state, survey){
		state.push( survey )
	},
	UPDATE_SURVEY(state, survey ){
		var curr = state.find( a => a.id == survey.id )
		var index = state.indexOf( curr )
		Vue.set(state, index, survey)
	},
	EMPTY_SURVEY( state, survey ){
		var curr = state.find( a => a == survey )
		var index = state.indexOf( curr )
		Vue.delete(state, index )
	}
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
